import { render, staticRenderFns } from "./SupportRequests.vue?vue&type=template&id=19256616&scoped=true&"
import script from "./SupportRequests.vue?vue&type=script&lang=js&"
export * from "./SupportRequests.vue?vue&type=script&lang=js&"
import style0 from "./SupportRequests.vue?vue&type=style&index=0&id=19256616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19256616",
  null
  
)

export default component.exports